import React from "react";
import IconButton from "@mui/material/IconButton";

import AddIcon from "@mui/icons-material/Add";
import useClasses from "../../useClasses";

const styles = (theme) => ({
  iconBtn: {
    backgroundColor: theme.palette.background.paper,
    border: "1px solid rgba(0, 0, 0, 0.12)",
    marginTop: -theme.spacing(2),
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },
  },
});

function CustomIconButton({ anchorRef, handleClick, disabled = false }) {
  const classes = useClasses(styles);
  return (
    <IconButton
      ref={anchorRef}
      aria-label="add"
      size="small"
      className={classes.iconBtn}
      aria-controls={"icon-button"}
      aria-expanded={"true"}
      aria-haspopup="menu"
      onClick={handleClick}
      disabled={disabled}
    >
      <AddIcon fontSize="small" />
    </IconButton>
  );
}

export default CustomIconButton;
